export default __webpack_public_path__ + "static/agency-user4-32cd24dcd3767eee1d75f9e598937586.png";